import { getClassification, getArticleById, getVenderById } from 'utils/api'

export const genPathByNavData = async ({ page, action, param }) => {
  if (!page) {
    return
  }
  if (page === 'default') {
    return { path: '/' }
  } else if (page === 'none' && action === 'openUrl') {
    return { path: param?.url, isExternalLink: true }
  } else if (page === 'couponList') {
    let url = '/coupon'
    if (action === 'addItem') {
      url += `?acquire=${param?.couponCode}`
    } else if (action === 'fill') {
      url += `?fill=${param?.couponCode}`
    }
    return { path: url }
  } else if (page === 'serviceClassification') {
    let postfix = ''
    if (action === 'bookService') {
      postfix = '/booking'
    }

    const [classification] = await getClassification(param?.classificationId)
    if (classification) {
      return { path: `/service/${classification?.identityCode}${postfix}` }
    }
  } else if (page === 'article') {
    const [article, error] = await getArticleById(param?.articleId)
    if (article && !error) {
      return { path: `/article/${article?.urlId}` }
    }
  } else if (page === 'vender') {
    const [vender, error] = await getVenderById(param?.venderId)
    if (vender && !error) {
      if (!vender?.introductionInfo?.isVisible) {
        return { path: '/vender?page=1' }
      }
      return { path: `/vender/${vender?.urlId}` }
    }
  }
  return { path: '/' }
}
